/**
 * SnapEdgeHighlight Component
 * Highlight the selected snap edge for azimuth alignment
 *
 * Extracted from GeoTiffViewerEmbedded.tsx (lines 1084-1107, 24 lines)
 *
 * Features:
 * - Thick yellow dashed line overlay on selected edge
 * - Used to visually indicate which edge is selected for module azimuth alignment
 * - Shows user which edge modules will be perpendicular to
 */

import React from 'react';
import { Polyline } from 'react-leaflet';

export interface SnapEdgeHighlightProps {
  /** Polygon coordinates [lat, lng][] */
  coords: [number, number][];

  /** Index of the edge to highlight (0-based) */
  edgeIndex: number;
}

/**
 * Highlight a specific polygon edge with a thick yellow dashed line
 *
 * Used to show which edge is selected for azimuth snapping when placing modules.
 * The highlighted edge determines the orientation of the module grid.
 */
export function SnapEdgeHighlight({
  coords,
  edgeIndex,
}: SnapEdgeHighlightProps) {
  if (edgeIndex < 0 || edgeIndex >= coords.length - 1) return null;

  const edgeCoords = [coords[edgeIndex], coords[edgeIndex + 1]];

  return (
    <Polyline
      positions={edgeCoords}
      pathOptions={{
        color: '#EBFD03',
        weight: 6,
        opacity: 1,
        dashArray: '10, 10',
      }}
    />
  );
}
